import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, BriefcaseBusiness, Linkedin, MapPin, Sparkles } from 'lucide-react';
const skills = ['SASS', 'AngularJS', 'JavaScript', 'React', 'User Experience (UX)', 'E-Commerce', 'Web Design', 'HTML/CSS', 'Application Development', 'WordPress Development', 'Drupal'];
const profileFacts = [{
  icon: BriefcaseBusiness,
  label: 'Focus',
  value: 'Web development, UX & e-commerce'
}, {
  icon: MapPin,
  label: 'Based in',
  value: 'Cape Town, South Africa'
}, {
  icon: Sparkles,
  label: 'Approach',
  value: 'Visual craft backed by practical delivery'
}];
export function PrivateProfileSection() {
  return <section id="private-profile" className="scroll-mt-24 border-y border-gold/20 bg-dark py-24" aria-labelledby="private-profile-heading" data-id="element-231" data-mp="3rfjge4u0woqq">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-232" data-mp="ns9g6uprkmi6">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 flex items-center gap-3" data-id="element-233" data-mp="nt2f59ihe7pr">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-4 py-2 font-inter text-xs font-bold uppercase tracking-[0.16em] text-gold" data-id="element-234" data-mp="3p1ih0auoj5in">
            <Sparkles size={14} data-id="element-235" data-mp="2rfubpw1ltxf" />
            Private professional profile
          </span>
          <span className="hidden h-px flex-1 bg-white/10 sm:block" data-id="element-236" data-mp="3tyinunzcscat" />
        </motion.div>

        <div className="grid gap-10 lg:grid-cols-[0.72fr_1.28fr] lg:items-start" data-id="element-237" data-mp="bsmfwddjtuxj">
          <motion.div initial={{
          opacity: 0,
          x: -26
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative mx-auto w-full max-w-sm lg:mx-0" data-id="element-238" data-mp="6ucj5yc6em9t">
            <div className="overflow-hidden rounded-2xl border-2 border-gold bg-dark-lighter" data-id="element-239" data-mp="cknjxk0sxswv">
              <img src="https://cdn.magicpatterns.com/uploads/o3U3oCBW7EJkGiWzzWWGLL/Black_And_White_Funny_Sphynx_Poster.png" alt="Sage Stephens" className="aspect-[4/5] w-full object-cover" data-id="element-240" data-mp="hifkf2fiinco" />
            </div>
            <div className="absolute -bottom-5 -right-5 -z-0 h-full w-full rounded-2xl border border-white/15" data-id="element-241" data-mp="vgnf13p2tcko" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 26
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} data-id="element-242" data-mp="10exdpoa0evb1">
            <p className="font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-243" data-mp="1j6zt6wax05jp">
              Digital CV
            </p>
            <h2 id="private-profile-heading" className="mt-3 font-syne text-5xl font-bold leading-none text-white md:text-6xl" data-id="element-244" data-mp="33q3bb3p4ngsz">
              Sage Stephens
            </h2>
            <p className="mt-4 font-syne text-xl text-white/75" data-id="element-245" data-mp="2uovr1pjg4ghw">
              Web Developer & UX Specialist
            </p>
            <p className="mt-7 max-w-2xl font-inter text-lg leading-relaxed text-white/65" data-id="element-246" data-mp="2prvldfqidfrb">
              I build thoughtful, high-performing websites that balance visual
              clarity with practical functionality. My work spans user
              experience, e-commerce and modern web development, with a focus on
              turning complex requirements into digital products people can use
              with confidence.
            </p>
            <p className="mt-4 max-w-2xl font-inter leading-relaxed text-white/55" data-id="element-247" data-mp="9zg2703sf1uw">
              I enjoy working closely with teams to shape the right approach,
              improve customer journeys and deliver flexible web solutions that
              support genuine business goals.
            </p>

            <div className="mt-8 flex flex-wrap gap-3" data-id="element-248" data-mp="3pxfkwhsa6gsl">
              <a href="https://www.linkedin.com/in/sageartitstudio/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-white/20 px-5 py-3 font-inter text-sm font-bold text-white transition-colors hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-249" data-mp="3bx4rb6zl6o3q">
                <Linkedin size={18} data-id="element-250" data-mp="3uwipy289gn0k" />
                View LinkedIn profile
              </a>
              <a href="#portfolio" className="inline-flex items-center gap-2 rounded-lg bg-gold px-5 py-3 font-inter text-sm font-bold text-true-white transition-transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-251" data-mp="3owe3mbe1e8m">
                Browse detailed work
                <ArrowDown size={17} data-id="element-252" data-mp="15j7tt6acq3fc" />
              </a>
            </div>

            <div className="mt-10 grid gap-3 sm:grid-cols-3" data-id="element-253" data-mp="11jqp4f2r1ab8">
              {profileFacts.map(fact => {
              const Icon = fact.icon;
              return <div key={fact.label} className="rounded-xl border border-white/10 bg-dark-lighter p-4" data-id="element-254" data-mp="1ab926h4efa03">
                    <Icon size={18} className="text-gold" data-id="element-255" data-mp="mlyadp510py3" />
                    <p className="mt-5 font-inter text-xs font-bold uppercase tracking-[0.14em] text-white/40" data-id="element-256" data-mp="ikuyfdq3ne25">
                      {fact.label}
                    </p>
                    <p className="mt-1 font-inter text-sm leading-relaxed text-white/75" data-id="element-257" data-mp="rkrh8ypt5ipa">
                      {fact.value}
                    </p>
                  </div>;
            })}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.12
      }} className="mt-16 border-t border-white/10 pt-10" data-id="element-258" data-mp="22zenb4zd710g">
          <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end" data-id="element-259" data-mp="2p0nfwms290z1">
            <div data-id="element-260" data-mp="1rd54f470lkrc">
              <p className="font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-261" data-mp="1rdoclt6v4us6">
                Core skills
              </p>
              <h3 className="mt-2 font-syne text-3xl font-bold text-white" data-id="element-262" data-mp="1w9n4hqreguxc">
                Tools and disciplines
              </h3>
            </div>
            <p className="max-w-md font-inter text-sm leading-relaxed text-white/50" data-id="element-263" data-mp="262kv6k6jpq71">
              A practical toolkit built across design, content platforms,
              front-end development and e-commerce delivery.
            </p>
          </div>

          <div className="mt-7 flex flex-wrap gap-3" data-id="element-264" data-mp="1divs0gc48oeq">
            {skills.map(skill => <span key={skill} className="rounded-full border border-white/10 bg-dark-lighter px-4 py-2 font-inter text-sm text-white/75" data-id="element-265" data-mp="15zmpn7211pz6">
                {skill}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}